import { render, staticRenderFns } from "./AlternativesViewDependenciesList.vue?vue&type=template&id=3f7b22f7"
import script from "./AlternativesViewDependenciesList.vue?vue&type=script&lang=ts"
export * from "./AlternativesViewDependenciesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports